export { default as CreacionPaletizacion } from "./CreacionPaletizacion";

